import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { QueryFilterDto, WorkflowQueryDto, QueryCreationDto, QueryResponseDto } from '@interfaces/queries';

function projectEndpoint(projectId: string): string {
	return `${environment.serverEndpoint}/api/projects/${projectId}`;
}

@Injectable({
	providedIn: 'root',
})
export class QueryRestService {
	// Tested by `workflow-item-queries.spec.ts`
	
	constructor(private httpClient: HttpClient) { }
	
	public list(projectId: string, filter: QueryFilterDto): Observable<WorkflowQueryDto[]> {
		const url = `${projectEndpoint(projectId)}/queries/list`;
		return this.httpClient.post<WorkflowQueryDto[]>(url, filter);
	}
	
	public get(projectId: string, queryId: string): Observable<WorkflowQueryDto> {
		const url = `${projectEndpoint(projectId)}/queries/query/${queryId}`;
		return this.httpClient.get<WorkflowQueryDto>(url);
	}
	
	public create(projectId: string, creationDto: QueryCreationDto): Observable<WorkflowQueryDto> {
		const url = `${projectEndpoint(projectId)}/queries/query`;
		return this.httpClient.post<WorkflowQueryDto>(url, creationDto);
	}
	
	public update(projectId: string, queryId: string, updateDto: QueryResponseDto): Observable<WorkflowQueryDto> {
		const url = `${projectEndpoint(projectId)}/queries/query/${queryId}`;
		return this.httpClient.post<WorkflowQueryDto>(url, updateDto);
	}
	
	public deleteComment(projectId: string, queryId: string, interactionIndex: number, message: string): Observable<void> {
		const url = `${projectEndpoint(projectId)}/queries/query/${queryId}/interaction/${interactionIndex}/delete`;
		return this.httpClient.post<void>(url, { message });
	}
}
